export const STORE_USER = 'user';
export const STORE_PROFILE = 'profile';
export const STORE_ROUTER = 'router';